import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormBuilder, Validators, FormArray, AbstractControl, FormControl } from '@angular/forms';
import { Artikel, StammdatenService, ArtikelStammdaten } from '@app/services/stammdaten.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-dialog-artikel',
  templateUrl: './dialog-artikel.component.html',
  styleUrls: ['./dialog-artikel.component.css'],
})
export class ArtikelDialogComponent implements OnInit {
  artikel: Artikel;
  frmArtikel: UntypedFormGroup;
  
  // Dropdown data properties
  artikelArten: string[] = [];
  basiseinheiten: any[] = [];
  ausbringungen: any[] = [];
  statusOptions: any[] = [];
  produktarten: any[] = [];
  loading = true;

  constructor(
    public dialogRef: MatDialogRef<ArtikelDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _fb: UntypedFormBuilder,
    private stammdatenService: StammdatenService
  ) {
    console.log('Dialog constructor called with data:', data);
    console.log('Dialog constructor data.artikel:', data?.artikel);
    this.artikel = data?.artikel || {
      id: 0,
      nummer: '',
      beschreibung: '',
      beschreibung_2: '',
      art: '',
      basiseinheit: '',
      code: '',
      beschreibung_code: '',
      in_code: '',
      alternative_beschreibung: '',
      belegtext: '',
      ausbringung: '',
      sortierung: 0,
      zulassungen: '',
      sicherheitsdatenblatt: '',
      systemkomponente: '',
      zulassungs_nummer: '',
      wirkstoff: '',
      status_id: 0,
      biozid_produktart: ''
    };

    this.frmArtikel = this._fb.group({
      id: [0],
      nummer: ['', Validators.required],
      beschreibung: ['', Validators.required],
      beschreibung_2: [''],
      art: [''],
      basiseinheit: [''],
      code: [''],
      beschreibung_code: [''],
      in_code: [''],
      alternative_beschreibung: [''],
      belegtext: [''],
      ausbringung: [''],
      sortierung: [0],
      zulassungen: [''],
      sicherheitsdatenblatt: [''],
      systemkomponente: [''],
      zulassungs_nummer: [''],
      wirkstoff: [''],
      status_id: [0],
      biozid_produktart: ['']
    });
  }

  ngOnInit() {
    console.log('Dialog ngOnInit called');
    // Load stammdaten for dropdowns first
    this.loadStammdaten();
  }

  /**
   * Load stammdaten for dropdown options
   */
  loadStammdaten() {
    console.log('Loading artikel stammdaten...');
    this.stammdatenService.getArtikelStammdaten().subscribe(
      (response: any) => {
        console.log('Artikel stammdaten loaded:', response);
        
        if (response) {
          const stammdaten = response;
          
          // Load artikel art (simple string)
          this.artikelArten = stammdaten.artikel_art ? [stammdaten.artikel_art] : [];
          
          // Load basiseinheiten
          this.basiseinheiten = stammdaten.artikel_basiseinheiten || [];
          
          // Load ausbringungen
          this.ausbringungen = stammdaten.artikel_ausbringungen || [];
          
          // Load status options
          this.statusOptions = stammdaten.artikel_status || [];
          
          // Load produktarten
          this.produktarten = stammdaten.artikel_produktarten || [];
        }
        
        this.loading = false;
        
        // Fill the form with the data after dropdowns are loaded
        this.frmArtikel.patchValue({
          id: this.artikel.id,
          nummer: this.artikel.nummer,
          beschreibung: this.artikel.beschreibung,
          beschreibung_2: this.artikel.beschreibung_2,
          art: this.artikel.art,
          basiseinheit: this.artikel.basiseinheit,
          code: this.artikel.code,
          beschreibung_code: this.artikel.beschreibung_code,
          in_code: this.artikel.in_code,
          alternative_beschreibung: this.artikel.alternative_beschreibung,
          belegtext: this.artikel.belegtext,
          ausbringung: this.artikel.ausbringung,
          sortierung: this.artikel.sortierung,
          zulassungen: this.artikel.zulassungen,
          sicherheitsdatenblatt: this.artikel.sicherheitsdatenblatt,
          systemkomponente: this.artikel.systemkomponente,
          zulassungs_nummer: this.artikel.zulassungs_nummer,
          wirkstoff: this.artikel.wirkstoff,
          status_id: this.artikel.status_id,
          biozid_produktart: this.artikel.biozid_produktart
        });
      },
      (error) => {
        console.error('Error loading artikel stammdaten:', error);
        this.loading = false;
        
        // Set empty arrays for dropdowns if loading fails
        this.artikelArten = [];
        this.basiseinheiten = [];
        this.ausbringungen = [];
        this.statusOptions = [];
        this.produktarten = [];
        
        // Still fill the form even if dropdown loading fails
        this.frmArtikel.patchValue({
          id: this.artikel.id,
          nummer: this.artikel.nummer,
          beschreibung: this.artikel.beschreibung,
          beschreibung_2: this.artikel.beschreibung_2,
          art: this.artikel.art,
          basiseinheit: this.artikel.basiseinheit,
          code: this.artikel.code,
          beschreibung_code: this.artikel.beschreibung_code,
          in_code: this.artikel.in_code,
          alternative_beschreibung: this.artikel.alternative_beschreibung,
          belegtext: this.artikel.belegtext,
          ausbringung: this.artikel.ausbringung,
          sortierung: this.artikel.sortierung,
          zulassungen: this.artikel.zulassungen,
          sicherheitsdatenblatt: this.artikel.sicherheitsdatenblatt,
          systemkomponente: this.artikel.systemkomponente,
          zulassungs_nummer: this.artikel.zulassungs_nummer,
          wirkstoff: this.artikel.wirkstoff,
          status_id: this.artikel.status_id,
          biozid_produktart: this.artikel.biozid_produktart
        });
      }
    );
  }

  /**
   * Dialog functions
   */
  onConfirm(): void {
    if (this.frmArtikel.valid) {
      // Close the dialog, return the form data
      this.artikel = this.frmArtikel.value;
      this.dialogRef.close({ event: 'save', data: this.frmArtikel.value });
    }
  }

  onDismiss(): void {
    // Close the dialog, return false
    this.dialogRef.close(false);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
} 